import { Block, Button, Page } from 'konsta/react';
import { useT } from '../i18n';
import { Logo } from '../components/Logo';

/** Introduction and safety warning, shown before registration. */
export function WelcomeScreen({ onContinue }: { onContinue: () => void }) {
  const t = useT();
  return (
    <Page className="flex flex-col">
      <div className="flex-1 overflow-auto px-5 pt-10">
        <div className="mb-6 flex justify-center">
          <Logo size={56} amharic />
        </div>
        <p className="mb-6 whitespace-pre-line text-lg leading-relaxed">{t('start.intro')}</p>
        <div className="whitespace-pre-line rounded-2xl bg-amber-100 p-4 leading-relaxed text-amber-950">
          {t('start.warning')}
        </div>
      </div>
      <Block className="pb-6">
        <Button large rounded onClick={onContinue}>
          {t('start.lets_start')}
        </Button>
      </Block>
    </Page>
  );
}
